import * as Yup from 'yup';

const contactSchema = Yup.object().shape({
  firstName: Yup.string().required('Please enter a first name'),
  lastName: Yup.string().required('Please enter a last name'),
  role: Yup.string().required('Please enter a role'),
  relationship: Yup.string(),
  phoneNumber: Yup.string()
    .required('Please enter a phone number')
    .test('valid-phone-number', 'Phone number is not valid', (phoneNumber) =>
      phoneNumber ? /^[0-9]{10}$/.test(phoneNumber) : true
    )
    .test(
      'start-with-zero',
      'Phone number can not begin with 0',
      (phoneNumber) => !(phoneNumber && phoneNumber[0] === '0')
    ),
  email: Yup.string().email(),
});

export const contactsSchema = Yup.array().of(contactSchema).min(1, 'At least one contact is required');
